import React from 'react'
import Notifications from '../modules/Notifications'
import PaymentInformation from '../modules/PaymentInformation'
import VoipModule from '../modules/VoipModule'
import ThingsToKnow from '../modules/ThingsToKnow'
import DataSource from '../DataSource'
import globals from '../globals'
import AjaxLoader from '../components/AjaxLoader'
import { connect } from 'react-redux'

class HomePhoneVoip extends React.Component {
    constructor (props) {
        super(props)

        this.state = {
            isLoaded: false,
            hasError: false,
            addresses: [],
            plans: []
        }
    }

    componentDidMount () {
        DataSource.getData(`/api/getVoipAddressesAndPlans/${this.props.customerId}`, result => {
            this.setState({
                addresses: result.addresses,
                plans: result.plans,
                isLoaded: true
            }, () => globals.animatePageIn(this.container))
        }, () => {
            this.setState({ hasError: true, isLoaded: true })
        })
    }

    render () {
        if (!this.state.isLoaded) {
            return <AjaxLoader />
        }

        return (
            <div ref={(el) => this.container = el} style={{ opacity: 0 }}>
                {this.state.addresses.length > 0
                    ? <Notifications icon='icon-voip.svg'>
                        <p>Got your broadband sorted but need a <span className='bold'>Home Phone</span> service.<br />This is the place to be. Your line rental is FREE with sweet call rates.</p>
                      </Notifications>
                    : ''}
                <VoipModule
                    title='Add a new Home Phone service'
                    isTransfer={false}
                    type='new-order'
                    includes='FREE line rental'
                    eventName='OrderNewVoipService'
                    isLoaded={this.state.isLoaded}
                    hasError={this.state.hasError}
                    addresses={this.state.addresses}
                    plans={this.state.plans}
                />
                {this.state.addresses.length > 0
                    ? <React.Fragment>
                        <PaymentInformation />
                        <ThingsToKnow type='homePhoneVoip' />
                      </React.Fragment>
                    : ''}
            </div>
        )
    }
}

const mapStateToProps = state => ({
    customerId: state.auth.id
})

export default connect(mapStateToProps)(HomePhoneVoip)



// WEBPACK FOOTER //
// ./resources/js/pages/HomePhoneVoip.js